import { createFileRoute } from "@tanstack/react-router";

import { CompareIndex } from "../components/compare/CompareIndex";
import { compareIndexHead } from "../lib/compare/head";
import { loadCompareCopy } from "../lib/compare/index";
import { COMPARE_UI } from "../lib/compare/ui";
import { documentHeaders } from "../lib/seo";

/** The comparison hub in English, at `/compare`. */
export const Route = createFileRoute("/compare/")({
  loader: () => loadCompareCopy("en"),
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData ? compareIndexHead("en", COMPARE_UI.en, loaderData) : {},
  component: EnglishCompareIndex,
});

function EnglishCompareIndex() {
  const copy = Route.useLoaderData();
  return <CompareIndex lang="en" ui={COMPARE_UI.en} copy={copy} />;
}
